import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import "./ThankYou.css"; // Optional if you want separate styles

export default function ThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear history stack so user cannot navigate back
    // React Router does not have a built-in method to clear history
    // But you can replace history entry so back button has nowhere to go
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      window.history.go(1);
    };
    
    // Clean up listener on unmount
    return () => {
      window.onpopstate = null;
    };
  }, []);

  return (
    <div className="app-container">
      <h1>Thank You!</h1>
      <h3>Your session has ended.</h3>
      <p>All participants have been disconnected.</p>
      {/* No back button */}
    </div>
  );
}




// dev.iniserve.com
// dev.warehouse.iniserve.com
// e-walkie-talkie.iniserve.com
// ini.talk.iniserve.com
// ini.warehouse.iniserve.com
// inibuy.iniserve.com
// iniserve.com
// privacy.iniserve.com	
// super.inibuy.iniserve.com
// talkie.iniserve.com
// terms.iniserve.com
// walkie.iniserve.com	
// www.unitedfins.com